import { render, staticRenderFns } from "./weiguitishi.vue?vue&type=template&id=655cfafc&scoped=true"
import script from "./weiguitishi.vue?vue&type=script&lang=js"
export * from "./weiguitishi.vue?vue&type=script&lang=js"
import style0 from "./weiguitishi.vue?vue&type=style&index=0&id=655cfafc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655cfafc",
  null
  
)

export default component.exports